import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
// import styles from "./styles/AnswerTextQuiz.module.css";

const AnswerTextQuiz = ({ as, rows, onChange, value, formik }) => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
      <Form.Label>Correct Answer</Form.Label>
      <Form.Control
        as={as}
        type="text"
        name={"textAnswer"}
        placeholder="Answer"
        rows={rows}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.textAnswer}
        isInvalid={formik.touched.textAnswer && formik.errors.textAnswer}
      />
      <Form.Control.Feedback type="invalid" className="text-left">
        {formik.touched.textAnswer && formik.errors.textAnswer}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

/* required: display name */
AnswerTextQuiz.displayName = "AnswerTextQuiz";

/* required: props types */
AnswerTextQuiz.propTypes = {};

/* required: default props */
AnswerTextQuiz.defaultProps = {};

export { AnswerTextQuiz };
